module.exports = __webpack_public_path__ + "static/media/Radio.da36c547.svg";